import React, { useState, useEffect } from "react";
import axios, { API_BASE_URL } from "../../../components/api/axios";
import "./First.css";

function First() {
  const [homeImages, setHomeImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch home background images from backend & preload them
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get("/home-images");
        const images = res.data || [];
        setHomeImages(images);

        // Preload all images into the browser cache immediately
        images.forEach((item) => {
          if (item.imagePath) {
            const img = new Image();
            img.src = `${API_BASE_URL}/${item.imagePath.replace(/\\/g, "/")}`;
          }
        });
      } catch (err) {
        console.error("Error fetching home images:", err);
      }
    };
    fetchImages();
  }, []);

  // Auto rotate images every 5 seconds
  useEffect(() => {
    if (homeImages.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % homeImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [homeImages]);

  // Handle Join button click
  const handleJoinNow = async () => {
    try {
      const res = await axios.get("/join-link");
      const data = res.data;
      if (data?.link) window.open(data.link, "_blank");
      else alert("Join link not found.");
    } catch (err) {
      console.error("Error fetching join link:", err);
      alert("Unable to open the join link right now.");
    }
  };

  return (
    <section id="home" className="home-section">
      {/* Background Slides positioned below the header */}
      <div className="home-slider">
        {homeImages.length > 0 ? (
          homeImages.map((image, index) => (
            <div
              key={image.id || index}
              className={`home-slide ${index === currentIndex ? "active" : ""}`}
              style={{
                backgroundImage: `url(${API_BASE_URL}/${image.imagePath.replace(/\\/g, "/")})`,
              }}
            />
          ))
        ) : (
          <div className="home-slide default-bg active" />
        )}
      </div>

      {/* Clean semi-transparent overlay matching the original appearance */}
      <div className="home-overlay"></div>

      <div className="home-content">
        <h1 className="hero-title">
          DADI INSTITUTE OF ENGINEERING <br />
          AND TECHNOLOGY
        </h1>

        <h2 className="hero-chapter-title">
          DIET ACM STUDENT CHAPTER
        </h2>

        <p className="hero-subtitle">
          Fostering innovation, building community, and empowering the next
          generation of technology leaders and creators.
        </p>

        <div className="home-buttons">
          <button
            className="btn-hero-primary"
            onClick={() =>
              document
                .getElementById("about")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            LEARN MORE
          </button>
          <button className="btn-hero-secondary" onClick={handleJoinNow}>
            JOIN NOW
          </button>
        </div>
      </div>

      {/* Carousel indicator dots anchored at the bottom of the hero screen */}
      {homeImages.length > 1 && (
        <div className="slider-dots">
          {homeImages.map((_, idx) => (
            <button
              key={idx}
              className={`dot-indicator ${idx === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default First;